import { combineReducers } from "@reduxjs/toolkit";
import { authSlice } from "./auth/auth.slice";
import { catalogTrackerSlice } from "./catalogTracker/catalogTracker.slice";
import { forecastingSlice } from "./forecasting/forecasting.slice";
import { performanceDashboardSlice } from "./performanceDashboard/performanceDashboard.slice";
import { replenishmentSlice } from "./replenishment/replenishment.slice";
import { salesBreakoutSlice } from "./salesBreakout/salesBreakout.slice";
import { salesDashboardSlice } from "./salesDashboard/salesDashboard.slice";
import { shipmentStatusSlice } from "./shipmentStatus/shipmentStatus.slice";
import { tableSlice } from "./table/table.slice";
import { inventoryPositionSlice } from "./InventoryPosition/inventoryPosition.slice";
import { rankChangesSlice } from "./RankChanges/rankChanges.slice";
import { advertisingSlice } from "./Advertising/Advertising.slice";
import { summaryChartSlice } from "./summaryChart/summaryChart.slice";
import { significantSalesChangesSlice } from "./significantSalesChanges/significantSalesChanges.slice";
import { rangerSlice } from "./ranger/ranger.slice";
import { promotionCalendarSlice } from "./promotionCalendar/promotionCalendar.slice";
import { paymentsSlice } from "./payments/payments.slice";
import { sellerOnboardingSlice } from "./SellerOnboarding/sellerOnboarding.slice";
import { salesChangesSlice } from "./salesChanges/salesChanges.slice";
import { dashboardSlice } from "./Dashboard/dashboard.slice";

const rootReducer = combineReducers({
  auth: authSlice.reducer,
  table: tableSlice.reducer,
  replenishment: replenishmentSlice.reducer,
  catalogTracker: catalogTrackerSlice.reducer,
  forecasting: forecastingSlice.reducer,
  performanceDashboard: performanceDashboardSlice.reducer,
  salesDashboard: salesDashboardSlice.reducer,
  salesBreakout: salesBreakoutSlice.reducer,
  shipmentStatus: shipmentStatusSlice.reducer,
  inventoryPosition: inventoryPositionSlice.reducer,
  rankChanges: rankChangesSlice.reducer,
  advertising: advertisingSlice.reducer,
  summaryChart: summaryChartSlice.reducer,
  significantSalesChanges: significantSalesChangesSlice.reducer,
  ranger: rangerSlice.reducer,
  promotionCalendar: promotionCalendarSlice.reducer,
  payments: paymentsSlice.reducer,
  sellerOnboarding: sellerOnboardingSlice.reducer,
  salesChanges: salesChangesSlice.reducer,
  dashboard: dashboardSlice.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
